import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import "./style.scss";

import { dataToJS, pathToJS, firebaseConnect } from "react-redux-firebase";
import BlankPage from "../blank/";
import Modal from "react-modal";
import DrawerToggle from "../../containers/drawer-toggle/";
class GroupStudents extends Component {
  constructor(props) {
    super(props);
    console.log("group student", props);
    this.state = {
      addingStudents: false,
      value: ""
    };
  }

  componentWillMount() {}

  componentWillUnmount() {}

  componentWillReceiveProps(props) {
    console.log(props);
    console.log("group student", props);
  }

  handleChange(event) {
    this.setState({ value: event.target.value });
  }

  closeAddStudents() {
    this.setState({ addingStudents: false });
  }
  openAddStudents() {
    this.setState({ addingStudents: true });
  }

  addStudents() {
    this.state.value.split("\n").map(student => {
      student.split(",");
      try {
        this.props.firebase.push(
          `/groups/${this.props.match.params.groupId}/students`,
          {
            firstName: student.split(",")[0].trim(),
            lastName: student.split(",")[1].trim(),
            email: student.split(",")[2].trim(),
            role: this.state.addToRole
          }
        );
      } catch (err) {
        console.error(`ignoring ${student}`, err);
      }
    });
  }
  render() {
    if (
      this.props.group &&
      this.props.profile &&
      this.props.profile.role === "admin"
    ) {
      return (
        <div className="flex-container">
          <div className="toolbar">
            <DrawerToggle /><h1>{this.props.group.name} Students</h1>
            <h1>
              <button onClick={this.openAddStudents.bind(this)}>
                Add
              </button>
            </h1>
          </div>
          <div className="content log">
            <div className="page">
              <div className="max-width">
                <h1>High School Students</h1>
                <div className="card no-padding">
                  <table>
                    <tbody>
                      <tr>
                        <th>
                          First Name
                        </th>
                        <th>
                          Last Name
                        </th>
                        <th>
                          Email
                        </th>
                      </tr>
                      {this.props.group.students &&
                        Object.keys(this.props.group.students)
                          .map((key, id) => ({
                            ...this.props.group.students[key],
                            _key: key
                          }))
                          .filter(student => student.role === "highschool")
                          .sort((a, b) => {
                            if (a.lastName < b.lastName) return -1;
                            if (a.lastName > b.lastName) return 1;
                            return 0;
                          })
                          .map(student => (
                            <tr key={student._key}>
                              <td>
                                {student.firstName}
                              </td><td>{student.lastName}</td>
                              <td>{student.email}</td>
                            </tr>
                          ))}
                    </tbody>
                  </table>
                </div>
                <h1>Undergraduates</h1>
                <div className="card no-padding">
                  <table>
                    <tbody>
                      <tr>
                        <th>
                          First Name
                        </th>
                        <th>
                          Last Name
                        </th>
                        <th>
                          Email
                        </th>
                      </tr>
                      {this.props.group.students &&
                        Object.keys(this.props.group.students)
                          .map((key, id) => ({
                            ...this.props.group.students[key],
                            _key: key
                          }))
                          .filter(student => student.role === "undergrad")
                          .sort((a, b) => {
                            if (a.lastName < b.lastName) return -1;
                            if (a.lastName > b.lastName) return 1;
                            return 0;
                          })
                          .map(student => (
                            <tr key={student._key}>
                              <td>
                                {student.firstName}
                              </td><td>{student.lastName}</td>
                              <td>{student.email}</td>
                            </tr>
                          ))}
                    </tbody>
                  </table>
                </div>
                <h1>Medical Students</h1>
                <div className="card no-padding">
                  <table>
                    <tbody>
                      <tr>
                        <th>
                          First Name
                        </th>
                        <th>
                          Last Name
                        </th>
                        <th>
                          Email
                        </th>
                      </tr>
                      {this.props.group.students &&
                        Object.keys(this.props.group.students)
                          .map((key, id) => ({
                            ...this.props.group.students[key],
                            _key: key
                          }))
                          .filter(student => student.role === "gradstudent")
                          .sort((a, b) => {
                            if (a.lastName < b.lastName) return -1;
                            if (a.lastName > b.lastName) return 1;
                            return 0;
                          })
                          .map(student => (
                            <tr key={student._key}>
                              <td>
                                {student.firstName}
                              </td><td>{student.lastName}</td>
                              <td>{student.email}</td>
                            </tr>
                          ))}
                    </tbody>
                  </table>

                </div>
              </div>

            </div>
          </div>

          <Modal
            isOpen={this.state.addingStudents}
            onRequestClose={this.closeAddStudents.bind(this)}
            contentLabel="Example Modal"
          >

            <form>
              <textarea
                name=""
                id=""
                cols="30"
                rows="10"
                value={this.state.value}
                onChange={this.handleChange.bind(this)}
                placeholder="first, last, email"
              />
              <br />
              Add To:
              <select
                onChange={(e => {
                  this.setState({ addToRole: e.target.value });
                }).bind(this)}
              >
                <option value="" />
                <option value="highschool">High School Students</option>
                <option value="undergrad">Undergraduates</option>
                <option value="gradstudent">Medical Students</option>
              </select>
            </form>

            <button onClick={this.addStudents.bind(this)}>Add Students</button>
            <button onClick={this.closeAddStudents.bind(this)}>Close</button>
          </Modal>
        </div>
      );
    } else
      return <BlankPage />;
  }
}

export default withRouter(
  connect(({ firebase }, router) => {
    return {
      group: dataToJS(firebase, `/groups/${router.match.params.groupId}`),
      students: dataToJS(
        firebase,
        `/groups/${router.match.params.groupId}/students`
      ),
      auth: pathToJS(firebase, "auth"),
      profile: pathToJS(firebase, "profile")
    };
  })(firebaseConnect(["/groups"])(GroupStudents))
);



// WEBPACK FOOTER //
// ./src/routes/group-students/index.js